import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const AiSafetyAppBust = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        November 07, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          AI-enabled safety app helps bust prostitution racket in Paharganj; six women rescued
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Image src="/static/media/about-photo-2.1f82417f40ffb13ef686.jpg" />
          <div className={classes.imageAttribution}>
            Say Help App
          </div>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              An AI-enabled women safety application, 'Say Help', designed to discreetly send real-time alerts in emergencies using voice activation, helped in rescuing six women from a Paharganj spa running a prostitution racket, the police said on Thursday.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              About Say Help App
            </Title>
            <Space h="md" />
            <Text>
              The app allows users to trigger alerts and send audio messages to the police or contacts. The app also connects to NGOs for help with gender violence and trafficking cases.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Alert and Investigation
            </Title>
            <Space h="md" />
            <Text>
              The police said an alert from the app was received on the intervening night of October 30-31 about a couple allegedly running a sex racket under the guise of a recreational facility called 'Galaxy Spa' in Nabi Karim area. A decoy officer, who was sent to the spa on November 1, confirmed the illegal activities, according to Deputy Commissioner of Police Nidhin Valsan.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Raid and Rescue
            </Title>
            <Space h="md" />
            <Text>
              A police team raided the premises, arrested the couple, and rescued six women. Of those rescued, two are from Delhi, two from West Bengal, and one each from Jharkhand and Uttar Pradesh. A case has been registered against the couple under the Immoral Traffic Prevention Act.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Real-time Alert System
            </Title>
            <Space h="md" />
            <Text>
              The AI-enabled platform provides real-time alerts through video, audio, and GPS data to authorities and emergency contacts, allowing swift police intervention.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor href="https://www.thehindu.com/profile/author/the-hindu-bureau-14355/" target="_blank">
              The Hindu Bureau
            </Anchor>
            . Source:{' '}
            <Anchor href="https://www.thehindu.com/news/cities/Delhi/ai-enabled-safety-app-helps-bust-prostitution-racket-in-paharganj-six-women-rescued/article70248484.ece" target="_blank">
              The Hindu
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default AiSafetyAppBust;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
